import { useCallback, useEffect, useState } from "react";
import { fetchSubscriptionBenefits } from "../subscriptionApi";
import { isPremiumAccount } from "../../../lib/accountStatus";

/**
 * Loads Professional free-deletion allowance from the server (30-day rolling period).
 */
export function useSubscriptionBenefits(accountStatus, { enabled = true } = {}) {
  const [benefits, setBenefits] = useState(null);
  const [loading, setLoading] = useState(Boolean(enabled));

  const refresh = useCallback(async () => {
    if (!enabled) {
      setBenefits(null);
      setLoading(false);
      return null;
    }
    setLoading(true);
    try {
      const data = await fetchSubscriptionBenefits();
      setBenefits(data);
      return data;
    } catch {
      setBenefits(null);
      return null;
    } finally {
      setLoading(false);
    }
  }, [enabled]);

  useEffect(() => {
    refresh();
  }, [refresh, accountStatus]);

  const isProfessional = isPremiumAccount(accountStatus) && Boolean(benefits?.isProfessional);
  const freeRemaining = isProfessional ? benefits?.freeRemaining ?? 0 : 0;

  return {
    benefits,
    loading,
    refresh,
    isProfessional,
    freeRemaining,
    freeAllowance: benefits?.freeAllowance ?? 0,
    freeUsed: benefits?.freeUsed ?? 0,
    periodEnd: benefits?.periodEnd ?? null,
  };
}

export default useSubscriptionBenefits;
